import React from 'react';
import {
    BottomLine,
    Content,
    FooterColumn,
    FooterColumnContent,
    Links,
    Logos,
    StyledFooter,
    TopLine,
    ToTop
} from './styles.Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faYoutube, faTwitter } from '@fortawesome/free-brands-svg-icons';
import BRLogo from '../../../assets/br-logo.svg';
import ARDLogo from '../../../assets/ard-logo.svg';
import AppStore from './assets/appStore.svg';
import PlayStore from './assets/playStore.svg';
import { animateScroll as scroll } from 'react-scroll';
import { Foldable } from '../foldable/Foldable';
import { A, H4 } from '../../../styles/styledComponents';
import { DeviceDetector } from '../../../utils/helper/browserDetection';

export const Footer: React.FC = () => {
    const onTopClicked = () => {
        DeviceDetector.isInternetExplorer
            ? window.scrollTo(0, 0)
            : scroll.scrollToTop({
                  duration: 500,
                  smooth: true
              });
    };

    return (
        <StyledFooter>
            <ToTop onClick={onTopClicked}>
                <FontAwesomeIcon icon={faAngleUp} />
            </ToTop>
            <TopLine>
                <A href="https://www.facebook.com/BR24/" target="_blank" rel="noreferrer noopener">
                    <FontAwesomeIcon icon={faFacebook} />
                </A>
                <A href="https://twitter.com/BR24" target="_blank" rel="noreferrer noopener">
                    <FontAwesomeIcon icon={faTwitter} />
                </A>
                <A href="https://www.instagram.com/br24/" target="_blank" rel="noreferrer noopener">
                    <FontAwesomeIcon icon={faInstagram} />
                </A>
                <A href="https://www.youtube.com/user/BR" target="_blank" rel="noreferrer noopener">
                    <FontAwesomeIcon icon={faYoutube} />
                </A>
            </TopLine>
            <Content>
                <FooterColumn>
                    <Foldable isResponsive={true} triggerText={<H4>Bayern</H4>} showDivider={true}>
                        <FooterColumnContent>
                            <A href="https://www.br.de/nachrichten/oberfranken,QXAQ0kx" light={true}>
                                {' '}
                                Oberfranken{' '}
                            </A>
                            <A href="https://www.br.de/nachrichten/mittelfranken,QXAPzbu" light={true}>
                                {' '}
                                Mittelfranken{' '}
                            </A>
                            <A href="https://www.br.de/nachrichten/unterfranken,QXAQ1wr" light={true}>
                                {' '}
                                Unterfranken{' '}
                            </A>
                            <A href="https://www.br.de/nachrichten/oberpfalz,QXAQ4GN" light={true}>
                                {' '}
                                Oberpfalz{' '}
                            </A>
                            <A href="https://www.br.de/nachrichten/niederbayern,QXAQ37J" light={true}>
                                {' '}
                                Niederbayern{' '}
                            </A>
                            <A href="https://www.br.de/nachrichten/schwaben,QXAQ5KO" light={true}>
                                {' '}
                                Schwaben{' '}
                            </A>
                            <A href="https://www.br.de/nachrichten/oberbayern,QXAQcxl" light={true}>
                                {' '}
                                Oberbayern{' '}
                            </A>
                        </FooterColumnContent>
                    </Foldable>
                </FooterColumn>

                <FooterColumn>
                    <Foldable isResponsive={true} triggerText={<H4>Rubriken</H4>} showDivider={true}>
                        <FooterColumnContent>
                            <A href="https://www.br.de/nachrichten/wirtschaft,QXAPwyN" light={true}>
                                {' '}
                                Wirtschaft{' '}
                            </A>
                            <A href="https://www.br.de/nachrichten/kultur,QXAPqxI" light={true}>
                                {' '}
                                Kultur{' '}
                            </A>
                            <A href="https://www.br.de/nachrichten/sport,QXAPvmL" light={true}>
                                {' '}
                                Sport{' '}
                            </A>
                            <A href="https://www.br.de/nachrichten/wissen,QXAPyRp" light={true}>
                                {' '}
                                Wissen{' '}
                            </A>
                            <A href="https://www.br.de/nachrichten/netzwelt,QXAPuSB" light={true}>
                                {' '}
                                Netzwelt{' '}
                            </A>
                        </FooterColumnContent>
                    </Foldable>
                </FooterColumn>

                <FooterColumn>
                    <Foldable isResponsive={true} triggerText={<H4>Medien</H4>} showDivider={true}>
                        <FooterColumnContent>
                            <A
                                href="https://www.br.de/mediathek/video/index.html"
                                rel="noopener noreferrer"
                                target="_blank"
                                light={true}
                            >
                                BR Mediathek Video
                            </A>
                            <A
                                href="https://www.br.de/mediathek/sendung/rundschau-av:584f4c183b467900117bf25f"
                                rel="noopener noreferrer"
                                target="_blank"
                                light={true}
                            >
                                Rundschau in der BR Mediathek
                            </A>

                            <A
                                href="https://www.br.de/static/radioplayer/radioplayer_de/b5aktuell/index.html?rpSt=b5&amp;rpSrp=1.0"
                                rel="noopener noreferrer"
                                target="_blank"
                                light={true}
                            >
                                B5 aktuell live hören
                            </A>

                            <A href="https://br.de/podcast" rel="noopener noreferrer" target="_blank" light={true}>
                                Podcasts
                            </A>

                            <A href="https://www.br.de/nachrichten/schlagzeilen" light={true}>
                                {' '}
                                Schlagzeilen{' '}
                            </A>
                        </FooterColumnContent>
                    </Foldable>
                </FooterColumn>

                <FooterColumn>
                    <H4 style={{ height: '3.5rem', display: 'flex', alignItems: 'center', padding: 0 }}>
                        BR24-App downloaden
                    </H4>
                    <A
                        href="https://apps.apple.com/de/app/br24/id998904798 "
                        rel="noopener noreferrer"
                        target="_blank"
                        light={true}
                    >
                        <AppStore />
                    </A>
                    <A
                        href="https://play.google.com/store/apps/details?id=de.br.sep.news.br24"
                        rel="noopener noreferrer"
                        target="_blank"
                        light={true}
                    >
                        <PlayStore />
                    </A>
                </FooterColumn>
            </Content>
            <BottomLine>
                <Logos>
                    <A href="https://www.br.de/" target="_blank" className="br-logo">
                        <BRLogo />
                    </A>
                    <A href="https://www.ard.de/" target="_blank" className="ard">
                        <ARDLogo />
                    </A>
                </Logos>
                <Links>
                    <A light={true} href="https://www.br.de/unternehmen/index.html" target="_blank">
                        Unternehmen
                    </A>
                    {' | '}
                    <A light={true} href="https://www.br.de/nachrichten/impressum" target="_blank">
                        Impressum
                    </A>
                    {' | '}
                    <A light={true} href="https://www.br.de/nachrichten/credits" target="_blank">
                        Credits
                    </A>
                    {' | '}
                    <A light={true} href="https://www.br.de/nachrichten/datenschutz" target="_blank">
                        Datenschutz
                    </A>
                    {' | '}
                    <A light={true} href="https://www.br.de/service/suche/hilfe/index.html" target="_blank">
                        Hilfe
                    </A>
                </Links>
            </BottomLine>
        </StyledFooter>
    );
};
